<template>
  <main>
    <h4 class="title is-4 m-t-40">{{this.$t('settings.kyc-title')}}</h4>
    <div v-if="token">
      <button v-if="processing" class="button is-primary is-loading">Verifing, please wait...</button>
    </div>
    <div v-else-if="data && data.userProfile">
        <div class="card">
          <div class="card-content">
            <div class="media">
              <div class="media-left">
            <figure class="image is-96x96">
              <img :src="data.userProfile.base64SelfieUri" />
            </figure>
          </div>
              <div class="media-content">
                <p class="title is-4">{{data.userProfile.fullName}} <small class="has-text-weight-normal is-size-5">{{data.userProfile.nationality}}</small></p>
                <div class="subtitle is-6 text">
                  <p>{{data.userProfile.emailAddress}} • <time>{{data.timestamp}}</time></p>
                  <p><b>Yoti#&nbsp;&nbsp;&nbsp;&nbsp;</b> {{data.rememberId}}</p>
                  <p><b>Recipt#</b> {{data.receiptId}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     <div v-else>
        <h5 class="m-b-8">{{$t("settings.connect-to-yoti")}}</h5>
        <div id="yoti-share-button"></div>
     </div>
    <p class="m-t-8 text">{{$t('settings.kyc-description', {'kyc-provider': 'Yoti'})}} </p>
  </main>
</template>

<script>
import kyc from '@/api/kyc'

export default {
  data () {
    return {
      token: null,
      data: null,
      processing: false
    }
  },
  methods: {
    async getData () {
      try {
        const r = await kyc.getDetails()
        console.log(r)
        if (r && r.data !== undefined) {
          this.data = r.data
        } else {
          this.loadYoti()
        }
      } catch (err) {
        this.loadYoti()
      }
    },
    loadYoti () {
      const self = this
      const yotiScript = document.createElement('script')
      yotiScript.onload = function () {
        window.Yoti.Share.init({
          'elements': [{
            'domId': 'yoti-share-button',
            'scenarioId': '846a0b7d-51e9-43d9-b205-568a6529e3fb',
            'clientSdkId': 'f9715d4b-e59c-4354-82d7-dc6890d39b3a',
            'button': {
              'label': self.$t('settings.connect-to-yoti')
            }
          }]
        })
      }
      yotiScript.async = true
      yotiScript.setAttribute('src', 'https://www.yoti.com/share/client/')
      document.head.appendChild(yotiScript)
    }
  },
  async mounted () {
    const q = this.$route.query
    if (q.token) {
      this.processing = true
      this.token = q.token
      try {
        const data = await kyc.callback(this.token)
        if (data.hasOwnProperty('message')) {
          this.token = null
          this.loadYoti()
          return
        }
        this.data = data
        this.processing = false
        this.token = null
      } catch (err) {
        this.processing = false
        this.token = null
        this.loadYoti()
      }
    } else {
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
  #yoti-share-button {
    height: 45px;
  }
  .media {
    margin-bottom: 0 !important
  }
</style>



// WEBPACK FOOTER //
// src/pages/settings/yoti-kyc.vue